var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
//Language Translation
import { useTranslation } from "react-i18next";
//Redux Functinality
import { useDispatch, useSelector } from "react-redux";
import { createOrders } from "../../reduxStore/actions/salesRepDataAction";
//user credentials
import { getLoggedInRepDetails, getLoggedInRepDetailsFromSession, getShippingRatesService } from "../../services/apiServices/salesRepDataService";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import store from "../../reduxStore/store";
import { APPLY_SHIPPING_COST_NO, APPLY_SHIPPING_COST_YES, CREATE_CHECKOUT, SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN, CREATE_ORDER_TYPE, DRAFT_ORDER, EDIT_ORDER_FLAG, SELECT_SHIPPING_AT_CHECKOUT, PaymentTermType, TOASTER_TIMEOUT, } from "../Constant";
import { formatDateForServer, parseDueInDaysFromApi } from "../SharedFunctions";
import { isLoading } from "../../services/behaviorSubjectService";
import { HandleEditDraftOrder } from "./EditDraftOrder";
import { useDeviceQueries } from "../../shared/Utilites";
export function ActionButtonsBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var t = useTranslation().t; //* Translation *
    var updateStateForEditOrder = HandleEditDraftOrder().updateStateForEditOrder;
    var isMobile = useDeviceQueries(); // mobile view
    var dispatch = useDispatch();
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); }); // ** Get Data **
    var _y = useState(""), orderNotes = _y[0], setOrderNotes = _y[1];
    var _z = useState(""), orderPONumber = _z[0], setOrderPONumber = _z[1];
    var _0 = useState({ msg: "", color: "blue" }), orderPlacedMsg = _0[0], setOrderPlacedMsg = _0[1];
    var checkResponsePopUpValue = (_c = (_b = (_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.ConfirmationPopUpStatus) === null || _b === void 0 ? void 0 : _b.isCheckOutPopUpVisible) !== null && _c !== void 0 ? _c : false;
    var _1 = useState(""), shippingCost = _1[0], setShippingCost = _1[1]; //Selected Shipping cost, to split and use
    var _2 = useState({ msg: "", open: false }), alertErrorMsg = _2[0], setAlertErrorMsg = _2[1];
    var _3 = useState([]), shippingCostData = _3[0], setShippingCostData = _3[1]; //All received Shipping data, to split and use
    var shippingAddressFlag = false;
    var _4 = useState(""), shippingAddresSet = _4[0], setShippingAddressSet = _4[1];
    var shippingAddresSetVariable = shippingAddresSet;
    var _5 = useState(""), applyShippingCost = _5[0], setApplyShippingCost = _5[1];
    var _6 = useState(false), isDisabledShippingCostRadioBtn_YesNo = _6[0], setIsDisabledShippingCostRadioBtn_YesNo = _6[1];
    var _7 = useState(false), openSelectShippingFlag = _7[0], setOpenSelectShippingFlag = _7[1];
    var _8 = useState(false), orderCreatedSuccessfully = _8[0], setOrderCreatedSuccessfully = _8[1];
    var _9 = useState(false), createOrderBtnLoader = _9[0], setCreateOrderBtnLoader = _9[1];
    var selectFeatures = ((_d = salesRepData.baseData) === null || _d === void 0 ? void 0 : _d.select) ? (_e = salesRepData.baseData) === null || _e === void 0 ? void 0 : _e.select : {};
    //editOrder
    var _10 = useState((_f = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) !== null && _f !== void 0 ? _f : {}), editOrderReduxData = _10[0], setEditOrderReduxData = _10[1];
    var _11 = useState(true), sendInvoiceFeature = _11[0], setSendInvoiceFeature = _11[1];
    var _12 = useState(""), selectedOrderType = _12[0], setSelectedOrderType = _12[1];
    var _13 = useState(false), discountApplyOnCheckout = _13[0], setDiscountApplyOnCheckout = _13[1];
    var _14 = useState(false), automaticDiscountOnCheckout = _14[0], setAutomaticDiscountOnCheckout = _14[1];
    var _15 = useState(null), paymentTerms = _15[0], setPaymentTerms = _15[1];
    //CheckoutConfirmation popup
    var _16 = useState((_j = (_h = (_g = salesRepData.baseData) === null || _g === void 0 ? void 0 : _g.ConfirmationPopUpStatus) === null || _h === void 0 ? void 0 : _h.isCheckOutPopUpVisible) !== null && _j !== void 0 ? _j : false), defaultPopupStateFromDb = _16[0], setDefaultPopupStateFromDb = _16[1];
    var isPopUpChecked = ((_k = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.checkoutConfirmationPopUp) === null || _k === void 0 ? void 0 : _k.IscheckBoxChecked) ? (_l = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.checkoutConfirmationPopUp) === null || _l === void 0 ? void 0 : _l.IscheckBoxChecked : false;
    var _17 = useState(false), isConfirmOpen = _17[0], setIsConfirmOpen = _17[1];
    var isEditOrder = ((_m = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _m === void 0 ? void 0 : _m.actionEvent) === EDIT_ORDER_FLAG;
    var _18 = useSelector(function (state) { var _a; return (_a = state.salesRepData) === null || _a === void 0 ? void 0 : _a.productTableData; }), selectedProductData = _18.selectedProductData, isQuantityError = _18.isQuantityError, isDiscountError = _18.isDiscountError, discountKeyValueObject = _18.discountKeyValueObject, selectedDiscountType = _18.selectedDiscountType, isDiscoutAppliedInEditDraft = _18.isDiscoutAppliedInEditDraft, discountTypeByVariant = _18.discountTypeByVariant;
    /** Parse any value to a valid Date or null. */
    var parseValueToDateOrNull = function (dateValue) {
        if (dateValue == null)
            return null;
        var d = dateValue instanceof Date ? dateValue : new Date(dateValue);
        return !isNaN(d.getTime()) ? d : null;
    };
    /** Build payment terms payload for create/update. Checkout does not use payment terms (empty and hidden). */
    var buildPaymentTermsData = function (paymentTermsVal, isEditOrder, selectFeatures, orderType) {
        var _a;
        var showPaymentTermsOption = (_a = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.PaymentTerms) !== null && _a !== void 0 ? _a : false;
        var shouldIncludePaymentTerms = showPaymentTermsOption && paymentTermsVal != null && (orderType === CREATE_ORDER_TYPE || orderType === DRAFT_ORDER);
        // CREATE_CHECKOUT excluded: Payment Terms are emptied and hidden when Order Type is Checkout
        if (!shouldIncludePaymentTerms || !paymentTermsVal)
            return {};
        try {
            var paymentTermsTemplateIdValue = paymentTermsVal.paymentTermsTemplateId != null && String(paymentTermsVal.paymentTermsTemplateId).trim() !== ""
                ? String(paymentTermsVal.paymentTermsTemplateId).trim()
                : null;
            var paymentTermsIdValue = isEditOrder && paymentTermsVal.orderPaymentTermsId != null && String(paymentTermsVal.orderPaymentTermsId).trim() !== "" ? paymentTermsVal.orderPaymentTermsId : null;
            var issueDateFormatted = paymentTermsVal.paymentTermType === PaymentTermType.NET || paymentTermsVal.paymentTermType === PaymentTermType.FIXED
                ? formatDateForServer(parseValueToDateOrNull(paymentTermsVal.issueDate))
                : null;
            var dueDateFormatted = formatDateForServer(parseValueToDateOrNull(paymentTermsVal.dueDate));
            var netDueInDays = parseDueInDaysFromApi(paymentTermsVal.dueInDays);
            return __assign(__assign(__assign(__assign(__assign({ paymentTermsTemplateId: paymentTermsTemplateIdValue }, (paymentTermsIdValue != null ? { paymentTermsId: paymentTermsIdValue } : {})), { paymentTermType: paymentTermsVal.paymentTermType || null }), (paymentTermsVal.paymentTermType === PaymentTermType.NET && netDueInDays != null ? { dueInDays: netDueInDays } : {})), (issueDateFormatted != null ? { issueDateInput: issueDateFormatted } : {})), (dueDateFormatted != null ? { dueDateInput: dueDateFormatted } : {}));
        }
        catch (_b) {
            return {};
        }
    };
    /** Payment Terms visibility: edit draft → show when feature on; duplicate → show when draft/state has PT or order type is Draft/Payment Pending. */
    var shouldShowPaymentTerms = function (selectFeaturesVal, selectedOrderTypeVal, editOrderReduxDataVal, paymentTermsVal, isEditOrderVal) {
        var _a;
        try {
            if (!(selectFeaturesVal === null || selectFeaturesVal === void 0 ? void 0 : selectFeaturesVal.PaymentTerms))
                return false;
            if (selectedOrderTypeVal === CREATE_CHECKOUT)
                return false;
            var isOrderTypeValid = selectedOrderTypeVal === CREATE_ORDER_TYPE || selectedOrderTypeVal === DRAFT_ORDER;
            var isDuplicate = (editOrderReduxDataVal === null || editOrderReduxDataVal === void 0 ? void 0 : editOrderReduxDataVal.isDuplicate) === true;
            var draftObj = editOrderReduxDataVal === null || editOrderReduxDataVal === void 0 ? void 0 : editOrderReduxDataVal.draftOrderObj;
            // API returns paymentTerms (camelCase); support payment_terms (snake_case) for compatibility
            var draftPaymentTerms = (_a = draftObj === null || draftObj === void 0 ? void 0 : draftObj.paymentTerms) !== null && _a !== void 0 ? _a : draftObj === null || draftObj === void 0 ? void 0 : draftObj.payment_terms;
            var hasDraftPaymentTerms = draftPaymentTerms != null && (draftPaymentTerms === null || draftPaymentTerms === void 0 ? void 0 : draftPaymentTerms.id) != null && String(draftPaymentTerms.id).trim() !== "";
            var hasPaymentTermsInState = paymentTermsVal != null || ((paymentTermsVal === null || paymentTermsVal === void 0 ? void 0 : paymentTermsVal.orderPaymentTermsId) != null && String(paymentTermsVal === null || paymentTermsVal === void 0 ? void 0 : paymentTermsVal.orderPaymentTermsId).trim() !== "");
            if (isEditOrderVal && !isDuplicate)
                return true;
            if (isEditOrderVal && isDuplicate)
                return hasPaymentTermsInState || hasDraftPaymentTerms || selectedOrderTypeVal === DRAFT_ORDER || selectedOrderTypeVal === CREATE_ORDER_TYPE;
            return isOrderTypeValid;
        }
        catch (_b) {
            return false;
        }
    };
    useEffect(function () {
        var resetShippingCost = function () {
            setApplyShippingCost("");
            setShippingCostData([]);
        };
        // Subscribe to Redux store and reset shipping cost on changes
        var unsubscribe = store.subscribe(function () {
            resetShippingCost();
        });
        // Reset shipping cost when customerInfo changes
        if (props.customerInfo) {
            resetShippingCost();
        }
        // Cleanup subscription on unmount
        return function () { return unsubscribe(); };
    }, [props.customerInfo]);
    var inputFieldsData = {
        newAddress: [
            {
                0: (_o = props.customerInfo) === null || _o === void 0 ? void 0 : _o.firstName,
                errorMsg: t("customerInvoice_FirstNameErrorMsg"),
            },
            {
                1: (_p = props.customerInfo) === null || _p === void 0 ? void 0 : _p.lastName,
                errorMsg: t("customerInvoice_lastNameErrorMsg"),
            },
            {
                2: (_q = props.customerInfo) === null || _q === void 0 ? void 0 : _q.address1,
                errorMsg: t("customerInvoice_Add1ErrorMsg"),
            },
            {
                3: (_r = props.customerInfo) === null || _r === void 0 ? void 0 : _r.selectCountry,
                errorMsg: t("customerInvoice_CountryErrorMsg"),
            },
            {
                4: (_s = props.customerInfo) === null || _s === void 0 ? void 0 : _s.selectCountryState,
                errorMsg: t("customerInvoice_StateErrorMsg"),
            },
            {
                5: (_t = props.customerInfo) === null || _t === void 0 ? void 0 : _t.city,
                errorMsg: t("customerInvoice_CityErrorMsg"),
            },
            {
                6: (_u = props.customerInfo) === null || _u === void 0 ? void 0 : _u.zipNumber,
                errorMsg: t("customerInvoice_ZipErrorMsg"),
            },
        ],
    };
    var orderOptions = [
        {
            value: DRAFT_ORDER,
            label: t("customerInvoice_DraftOrderBtn"),
            description: t("customerInvoice_DraftOrderDescription"),
            hide: !selectFeatures.CreateInvoice,
        },
        {
            value: CREATE_ORDER_TYPE,
            label: t("customerInvoice_PaymentPending"),
            description: t("customerInvoice_PaymentPendingDescription"),
            hide: !selectFeatures.CreateOrder,
        },
        {
            value: CREATE_CHECKOUT,
            label: t("customerInvoice_Checkout"),
            description: t("customerInvoice_CheckoutDescription"),
            hide: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateCheckout),
        },
    ];
    useEffect(function () {
        var _a, _b, _c;
        //for edit order
        if (isEditOrder) {
            // Check if we're on the Create Order tab (index 1) and it's not a B2B order
            var activeTab = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.activeTab;
            var isCreateOrderTabActive = (activeTab === null || activeTab === void 0 ? void 0 : activeTab.activeTabIndex) === 1;
            var b2bCompany = (_c = (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _b === void 0 ? void 0 : _b.draftOrderObj) === null || _c === void 0 ? void 0 : _c.b2bCompany;
            var isB2BEditOrder = (b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.id) && (b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.location_id);
            // Only patch customer details if we're on Create Order tab AND it's not a B2B order
            if (isCreateOrderTabActive && !isB2BEditOrder) {
                updateStateForEditOrder("autoFatchDataForEditOrder", {
                    props: props,
                    setOrderNotes: setOrderNotes,
                    setAlertErrorMsg: setAlertErrorMsg,
                    setApplyShippingCost: setApplyShippingCost,
                    setShippingCost: setShippingCost,
                    GetShippingRatesOnSelectedAddress: GetShippingRatesOnSelectedAddress,
                    handleUpdateReduxState: handleUpdateReduxState,
                    newProductTable: true,
                    setDiscountApplyOnCheckout: setDiscountApplyOnCheckout,
                    setOrderPONumber: setOrderPONumber,
                    setAutomaticDiscountOnCheckout: setAutomaticDiscountOnCheckout,
                    setPaymentTerms: setPaymentTerms,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditOrder]);
    useEffect(function () {
        //Empty shipping "Cost" & "Options"
        setShippingCost("");
        setShippingCostData([]);
        setApplyShippingCost("");
        setIsDisabledShippingCostRadioBtn_YesNo(false);
        setPaymentTerms(null);
    }, [props.customerInfo.shippingAddress, props.customerInfo.zipNumber]);
    useEffect(function () {
        if (checkResponsePopUpValue && !isPopUpChecked) {
            setDefaultPopupStateFromDb(true);
        }
        else {
            setDefaultPopupStateFromDb(isPopUpChecked);
        }
    }, [isPopUpChecked, checkResponsePopUpValue]);
    var successMessages = {
        createOrder: t("customerInvoice_OrderCreatedSuccessfullyMsg"),
        draftOrder: t("customerInvoice_DraftOrderCreatedSuccessfullyMsg"),
        CreateCheckout: t("customerInvoice_DraftOrderCreatedSuccessfullyMsg") + ", " + t("RepCheckout_RedirectionMsg"),
    };
    var loadingMessages = {
        draftOrder: t("customerInvoice_CreatingDraft_Msg"),
        CreateCheckout: t("customerInvoice_CreatingDraft_Msg"),
        createOrder: t("customerInvoice_Creating_Msg"),
    };
    var handleOrderTypeChange = function (value) {
        setSelectedOrderType(value);
        if (value === CREATE_ORDER_TYPE) {
            setSendInvoiceFeature(true);
        }
        // When Order Type is Checkout: empty Payment Terms and hide section (visibility in shouldShowPaymentTerms)
        if (value === CREATE_CHECKOUT) {
            setPaymentTerms(null);
        }
    };
    //  Create Order API
    var CreateOrder = function (orderType) { return __awaiter(_this, void 0, void 0, function () {
        var _a, CustomerId, email, customerEmail, customerId, selectedAddressObject, createOrderDataObject, customer_Address, shipping_Name, shipping_Cost, selectShippingCost, cost, title, updatedSelectedProducts, isDuplicate, isEditOrderForAPI, updatedDiscountKeyValueObject, key, variantId, paymentTermsData, successDataPost, errorMsg, error_1;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        return __generator(this, function (_0) {
            switch (_0.label) {
                case 0:
                    _0.trys.push([0, 3, , 4]);
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, email = _a.email;
                    customerEmail = email;
                    customerId = CustomerId;
                    selectedAddressObject = {};
                    checkConditions(CREATE_ORDER_TYPE, orderType); //checking shipping address
                    //show error msg "Would you like to add Shipping cost?
                    if ((_b = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _b === void 0 ? void 0 : _b.showShippingCalculation) {
                        if (shippingAddressFlag && shippingAddresSetVariable !== "" && applyShippingCost === "") {
                            setAlertErrorMsg({ msg: t("customerInvoice_ShippingCostAddOrNot_Msg"), open: true, severity: "warning" });
                            return [2 /*return*/];
                        }
                        if (orderType !== DRAFT_ORDER && applyShippingCost === APPLY_SHIPPING_COST_YES && shippingCost === "") {
                            setAlertErrorMsg({ msg: t("customerInvoice_EditOrder_NoAutoSelectedShippingCost"), open: true, severity: "warning" });
                            return [2 /*return*/];
                        }
                    }
                    if (!(orderType === DRAFT_ORDER ||
                        (shippingAddressFlag &&
                            shippingAddresSetVariable !== "" &&
                            (!((_c = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _c === void 0 ? void 0 : _c.showShippingCalculation) || applyShippingCost === APPLY_SHIPPING_COST_NO || shippingCost !== "")))) return [3 /*break*/, 2];
                    createOrderDataObject = {};
                    customer_Address = [];
                    shipping_Name = null;
                    shipping_Cost = null;
                    selectShippingCost = shippingCost === null || shippingCost === void 0 ? void 0 : shippingCost.split("/");
                    cost = selectShippingCost === null || selectShippingCost === void 0 ? void 0 : selectShippingCost.pop();
                    title = selectShippingCost === null || selectShippingCost === void 0 ? void 0 : selectShippingCost.join("/");
                    if (title !== "" && cost !== "") {
                        shipping_Name = title;
                        shipping_Cost = cost;
                    }
                    // if apply shipping cost selected to "No"
                    if (applyShippingCost === APPLY_SHIPPING_COST_NO) {
                        shipping_Name = "Custom";
                        shipping_Cost = null;
                    }
                    if (shippingCost === SELECT_SHIPPING_AT_CHECKOUT) {
                        shipping_Name = "";
                        shipping_Cost = null;
                    }
                    updatedSelectedProducts = selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.map(function (item) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                        var isCustomLineItem = (item === null || item === void 0 ? void 0 : item.custom) === true || (item === null || item === void 0 ? void 0 : item.isCustom) === true || (typeof (item === null || item === void 0 ? void 0 : item.variantId) === "string" && ((_a = item === null || item === void 0 ? void 0 : item.variantId) === null || _a === void 0 ? void 0 : _a.startsWith("custom:")));
                        if (isCustomLineItem) {
                            var isPhysical = !!((_b = item === null || item === void 0 ? void 0 : item.isPhysicalProduct) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.requires_shipping);
                            // Use weight and weight_unit directly from variant (from backend)
                            // No conversion from grams - backend provides weight and weight_unit separately
                            var weight = undefined;
                            var weight_unit = undefined;
                            if (isPhysical && (item === null || item === void 0 ? void 0 : item.weight) !== undefined && (item === null || item === void 0 ? void 0 : item.weight) !== null && (item === null || item === void 0 ? void 0 : item.weight) > 0 && (item === null || item === void 0 ? void 0 : item.weight_unit)) {
                                weight = item.weight;
                                weight_unit = item.weight_unit;
                            }
                            return __assign(__assign(__assign(__assign({}, item), { custom: true, isCustom: true, variantId: null, title: (_d = (_c = item === null || item === void 0 ? void 0 : item.title) !== null && _c !== void 0 ? _c : item === null || item === void 0 ? void 0 : item.name) !== null && _d !== void 0 ? _d : "", price: (_e = item === null || item === void 0 ? void 0 : item.price) !== null && _e !== void 0 ? _e : (Number((_f = item === null || item === void 0 ? void 0 : item.variantPrice) !== null && _f !== void 0 ? _f : 0) || 0).toFixed(2), quantity: Math.max(1, Number((_g = item === null || item === void 0 ? void 0 : item.quantity) !== null && _g !== void 0 ? _g : 1) || 1), taxable: (_h = item === null || item === void 0 ? void 0 : item.taxable) !== null && _h !== void 0 ? _h : true, requires_shipping: isPhysical }), (weight !== undefined && { weight: weight })), (weight_unit !== undefined && { weight_unit: weight_unit }));
                        }
                        var updatedVariantId = ((_j = item === null || item === void 0 ? void 0 : item.variantId) !== null && _j !== void 0 ? _j : "").toString().replace("gid://shopify/ProductVariant/", "");
                        return __assign(__assign({}, item), { variantId: updatedVariantId });
                    });
                    if (shippingAddresSetVariable === "formAddress") {
                        customer_Address = [
                            {
                                fname: ((_d = props.customerInfo) === null || _d === void 0 ? void 0 : _d.firstName) || "",
                                lastname: ((_e = props.customerInfo) === null || _e === void 0 ? void 0 : _e.lastName) || "",
                                address1: ((_f = props.customerInfo) === null || _f === void 0 ? void 0 : _f.address1) || "",
                                address2: ((_g = props.customerInfo) === null || _g === void 0 ? void 0 : _g.address2) || "",
                                province: ((_h = props.customerInfo) === null || _h === void 0 ? void 0 : _h.selectCountryState) || "",
                                city: ((_j = props.customerInfo) === null || _j === void 0 ? void 0 : _j.city) || "",
                                country: ((_k = props.customerInfo) === null || _k === void 0 ? void 0 : _k.selectCountryCode) || "",
                                zip: ((_l = props.customerInfo) === null || _l === void 0 ? void 0 : _l.zipNumber) || "",
                            },
                            {
                                fname: props.customerInfo.billing_firstName || "",
                                lastname: props.customerInfo.billing_lastName || "",
                                address1: props.customerInfo.billing_address1 || "",
                                address2: props.customerInfo.billing_address2 || "",
                                province: props.customerInfo.billing_selectCountryState || "",
                                city: props.customerInfo.billing_city || "",
                                country: props.customerInfo.billing_selectCountryCode || "",
                                zip: props.customerInfo.billing_zipNumber || "",
                            },
                        ];
                    }
                    if (shippingAddresSetVariable === "formAddress") {
                        customer_Address[0]["company"] = ((_m = props.customerInfo) === null || _m === void 0 ? void 0 : _m.companyName) ? props.customerInfo.companyName : (_o = selectedAddressObject === null || selectedAddressObject === void 0 ? void 0 : selectedAddressObject.company) !== null && _o !== void 0 ? _o : "";
                        customer_Address[0]["phone"] = ((_p = props.customerInfo) === null || _p === void 0 ? void 0 : _p.mobileNumber) ? (_q = props.customerInfo) === null || _q === void 0 ? void 0 : _q.mobileNumber : (_r = selectedAddressObject === null || selectedAddressObject === void 0 ? void 0 : selectedAddressObject.phone) !== null && _r !== void 0 ? _r : "";
                        customer_Address[1]["company"] = ((_s = props.customerInfo) === null || _s === void 0 ? void 0 : _s.billing_companyName) ? props.customerInfo.billing_companyName : "";
                        customer_Address[1]["phone"] = ((_t = props.customerInfo) === null || _t === void 0 ? void 0 : _t.billing_mobileNumber) ? (_u = props.customerInfo) === null || _u === void 0 ? void 0 : _u.billing_mobileNumber : "";
                    }
                    isDuplicate = (editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.isDuplicate) === true;
                    isEditOrderForAPI = isDuplicate ? false : isEditOrder;
                    updatedDiscountKeyValueObject = {};
                    if (discountKeyValueObject && ((_v = Object.keys(discountKeyValueObject)) === null || _v === void 0 ? void 0 : _v.length) > 0) {
                        for (key in discountKeyValueObject) {
                            if (key !== "discountOnSubTotal") {
                                if (typeof key === "string" && key.includes("gid://shopify/ProductVariant/")) {
                                    variantId = key === null || key === void 0 ? void 0 : key.split("gid://shopify/ProductVariant/")[1];
                                    updatedDiscountKeyValueObject[variantId] = discountKeyValueObject[key];
                                }
                            }
                            else {
                                updatedDiscountKeyValueObject[key] = discountKeyValueObject[key];
                            }
                        }
                    }
                    paymentTermsData = buildPaymentTermsData(paymentTerms, isEditOrder, selectFeatures, orderType);
                    //Data Post...
                    createOrderDataObject = __assign(__assign(__assign({}, (isEditOrderForAPI ? {} : { email: customerEmail })), (isEditOrderForAPI
                        ? {
                            repEmail: customerEmail,
                            orderId: (_w = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _w === void 0 ? void 0 : _w.id,
                            orderTags: (_x = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _x === void 0 ? void 0 : _x.tags,
                            additionalNoteDetails: (_z = (_y = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _y === void 0 ? void 0 : _y.note_attributesList) !== null && _z !== void 0 ? _z : [],
                        }
                        : {})), __assign({ prods: JSON.stringify(updatedSelectedProducts !== null && updatedSelectedProducts !== void 0 ? updatedSelectedProducts : []), customerId: customerId, Index: -1, fnamecus: props.customerInfo.customerName, cusemail: props.customerInfo.emailId, wholesale: "false", message: orderNotes, cusAddress: customer_Address, shippingtitle: shipping_Name, shippingprice: shipping_Cost, IsAdressFromCustmerInvoice: false, completeDraftOrder: orderType === CREATE_ORDER_TYPE, isNewaddress: true, pro: false, saveAsDraftOrder: false, sendInvoice: sendInvoiceFeature, doNotShowCheckOutInfoPopUp: orderType === CREATE_CHECKOUT ? defaultPopupStateFromDb : false, 
                        // discountApplyOnSubTotal: discountKeyValueObject?.discountOnSubTotal != null ? Number(discountKeyValueObject.discountOnSubTotal) : 0,
                        discountType: selectedDiscountType, lineItemDiscountObject: updatedDiscountKeyValueObject, discountApplyOnSubTotal: (updatedDiscountKeyValueObject === null || updatedDiscountKeyValueObject === void 0 ? void 0 : updatedDiscountKeyValueObject.discountOnSubTotal) ? Number(updatedDiscountKeyValueObject === null || updatedDiscountKeyValueObject === void 0 ? void 0 : updatedDiscountKeyValueObject.discountOnSubTotal) : 0, backofficeDiscountApplied: isDiscoutAppliedInEditDraft !== null && isDiscoutAppliedInEditDraft !== void 0 ? isDiscoutAppliedInEditDraft : false, isApplyDiscountOnCheckout: discountApplyOnCheckout !== null && discountApplyOnCheckout !== void 0 ? discountApplyOnCheckout : false, ponumber: orderPONumber, isAutomaticDiscountOnCheckout: automaticDiscountOnCheckout !== null && automaticDiscountOnCheckout !== void 0 ? automaticDiscountOnCheckout : false }, paymentTermsData));
                    setOrderPlacedMsg({ msg: loadingMessages[orderType], color: "blue" });
                    isLoading.next(true);
                    props === null || props === void 0 ? void 0 : props.setOrderCreatedSuccesfullyFlag(false);
                    setCreateOrderBtnLoader(true);
                    return [4 /*yield*/, createOrders(createOrderDataObject, isEditOrderForAPI)];
                case 1:
                    successDataPost = _0.sent();
                    setCreateOrderBtnLoader(false);
                    if (typeof successDataPost === "string" && successDataPost !== "") {
                        handleSuccess(orderType, successDataPost);
                    }
                    else if (successDataPost && typeof successDataPost === "object" && successDataPost.exceptionMessage) {
                        // Edit/create returned an error message from server
                        setOrderPlacedMsg({ msg: successDataPost.exceptionMessage, color: "red" });
                        setAlertErrorMsg({ msg: successDataPost.exceptionMessage, open: true, severity: "error" });
                        setTimeout(function () {
                            setOrderPlacedMsg({ msg: "", color: "" });
                        }, 2000);
                    }
                    else if (successDataPost && isEditOrderForAPI) {
                        // Handle success for isEditOrder type (complete draft order)
                        handleSuccess(orderType);
                    }
                    else {
                        errorMsg = successDataPost != null && typeof successDataPost === "object" && successDataPost.exceptionMessage
                            ? successDataPost.exceptionMessage
                            : t("customerInvoice_ErrorMsgTryAgain");
                        setOrderPlacedMsg({ msg: errorMsg, color: "red" });
                        setAlertErrorMsg({ msg: errorMsg, open: true, severity: "error" });
                        setTimeout(function () {
                            setOrderPlacedMsg({ msg: "", color: "" });
                        }, 2000);
                    }
                    setIsConfirmOpen(false);
                    isLoading.next(false);
                    _0.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _0.sent();
                    setAlertErrorMsg({ msg: t("customerInvoice_ErrorMsgTryAgain"), open: true, severity: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSuccess = function (orderType, successDataPost) {
        var _a;
        props === null || props === void 0 ? void 0 : props.setIsCustomerSelected(false);
        handleUpdateReduxState({}, SalesRepDataActionType.CREATE_ORDER_TAB);
        setOrderPlacedMsg({ msg: successMessages[orderType], color: "green" });
        setAlertErrorMsg({ msg: successMessages[orderType], open: true, severity: "success" });
        setOrderCreatedSuccessfully(true);
        setTimeout(function () {
            setOrderPlacedMsg({ msg: "", color: "" });
        }, TOASTER_TIMEOUT);
        props === null || props === void 0 ? void 0 : props.setOrderCreatedSuccesfullyFlag(true);
        handleUpdateReduxState([], SalesRepDataActionType.DRAFT_ORDER_DATA);
        handleUpdateReduxState({}, SalesRepDataActionType.EDIT_DRAFT_ORDER);
        setSelectedOrderType("");
        setPaymentTerms(null);
        // Redirect to checkout
        if (orderType === CREATE_CHECKOUT) {
            setIsConfirmOpen(false);
            var invoiceRedirectUrl_1 = isEditOrder ? (_a = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj) === null || _a === void 0 ? void 0 : _a.invoice_url : successDataPost;
            var shopName_1 = getLoggedInRepDetails().shopName;
            setTimeout(function () {
                if (typeof invoiceRedirectUrl_1 === "string" && invoiceRedirectUrl_1) {
                    var appendSkipShopPay = shopName_1 === SHOP_CHECKOUT_SKIP_SHOP_PAY_DOMAIN;
                    window.location.href = appendSkipShopPay ? "".concat(invoiceRedirectUrl_1).concat(invoiceRedirectUrl_1.includes("?") ? "&" : "?", "skip_shop_pay=true") : invoiceRedirectUrl_1;
                }
                else {
                    window.location.href = invoiceRedirectUrl_1;
                }
            }, 5000);
        }
        setEditOrderReduxData({});
        isEditOrder = false;
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    //check Conditions before canculating shipping cost, Shipping Address validation
    var checkConditions = function (uses, event) {
        var errorMsgType = uses === "GetShippingRates" ? t("ShippingCost_CustomerAddressAndCartProductError") : t("Address_Not_Found_Error_Msg");
        // if products not selected then show error
        if ((selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.length) === 0 && !isEditOrder) {
            setAlertErrorMsg({ msg: errorMsgType, open: true, severity: "warning" });
            return;
        }
        if (inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress.every(function (fieldObject, index) { return fieldObject[index] === ""; })) {
            shippingAddressFlag = false;
            if (event !== DRAFT_ORDER && !isEditOrder) {
                setAlertErrorMsg({ msg: errorMsgType, open: true, severity: "warning" });
                return;
            }
            if (event === DRAFT_ORDER || isEditOrder) {
                setShippingAddressSet("formAddress");
                shippingAddresSetVariable = "formAddress";
            }
            else {
                setShippingAddressSet("");
                shippingAddresSetVariable = "";
            }
        }
        else {
            if (inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress.every(function (fieldObject, index) { return fieldObject[index] !== ""; })) {
                shippingAddressFlag = true;
                setShippingAddressSet("formAddress");
                shippingAddresSetVariable = "formAddress";
            }
            else if (event !== DRAFT_ORDER) {
                checkAddressInputField();
            }
            else {
                setShippingAddressSet("formAddress");
                shippingAddresSetVariable = "formAddress";
            }
        }
    };
    var handleApplyShippingRadio = function (option) {
        setShippingCost("");
        setShippingCostData([]);
        setApplyShippingCost(option);
        if (option && option === APPLY_SHIPPING_COST_YES) {
            GetShippingRatesOnSelectedAddress();
        }
    };
    //get Shipping Cost using Api Call
    var GetShippingRatesOnSelectedAddress = function () { return __awaiter(_this, void 0, void 0, function () {
        var customerAddressesListArray, CustomerAddressData, responseShippingRates;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    setShippingCost("");
                    setShippingCostData([]);
                    setApplyShippingCost(APPLY_SHIPPING_COST_YES);
                    setIsDisabledShippingCostRadioBtn_YesNo(false);
                    customerAddressesListArray = [];
                    if ((props === null || props === void 0 ? void 0 : props.customerAddressesList) && ((_a = props === null || props === void 0 ? void 0 : props.customerAddressesList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        customerAddressesListArray = props.customerAddressesList;
                    }
                    else {
                        customerAddressesListArray = (_c = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.customerNewUpdatedData) === null || _c === void 0 ? void 0 : _c.customerAddressesList;
                    }
                    checkConditions("GetShippingRates", ""); //checking shipping address
                    if (!(shippingAddressFlag && shippingAddresSetVariable !== "")) return [3 /*break*/, 2];
                    CustomerAddressData = {
                        customerCountry: "",
                        customerProvince: "",
                        customerZip: "",
                    };
                    if (shippingAddresSetVariable === "formAddress") {
                        CustomerAddressData.customerCountry = props.customerInfo.selectCountry;
                        CustomerAddressData.customerProvince = props.customerInfo.selectCountryState ? props.customerInfo.selectCountryState : props.customerInfo.city;
                        CustomerAddressData.customerZip = props.customerInfo.zipNumber;
                    }
                    if (CustomerAddressData.customerCountry === "Great Britain (UK)") {
                        CustomerAddressData.customerCountry = "United Kingdom";
                    }
                    else if (CustomerAddressData.customerCountry === "United States of America") {
                        CustomerAddressData.customerCountry = "United States";
                    }
                    setShippingCost(t("customerInvoice_CalculatingShippingRates_Msg"));
                    return [4 /*yield*/, getShippingRatesService(CustomerAddressData)];
                case 1:
                    responseShippingRates = _e.sent();
                    setShippingCost("");
                    setOpenSelectShippingFlag(true);
                    if (responseShippingRates != null &&
                        responseShippingRates != undefined &&
                        responseShippingRates.hasOwnProperty("shipping_rates") &&
                        (responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message) === "Success") {
                        setShippingCostData(responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.shipping_rates);
                        if (((_d = responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.shipping_rates) === null || _d === void 0 ? void 0 : _d.length) === 0) {
                            setAlertErrorMsg({ msg: t("ShippingCost_AddressError"), open: true, severity: "warning" });
                            setApplyShippingCost("");
                        }
                        return [2 /*return*/, true];
                    }
                    else {
                        if ((responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message) === "Success") {
                            setAlertErrorMsg({ msg: t("customerInvoice_ShippingCostErrorMsg_TryAgain"), open: true });
                            setApplyShippingCost("");
                        }
                        else {
                            setAlertErrorMsg({ msg: responseShippingRates === null || responseShippingRates === void 0 ? void 0 : responseShippingRates.message, open: true });
                            setApplyShippingCost("");
                        }
                        return [2 /*return*/, false];
                    }
                    _e.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleSelectShippingAddress = function (set) {
        setShippingAddressSet(set);
        setShippingCost("");
        setShippingCostData([]);
        setApplyShippingCost("");
        setIsDisabledShippingCostRadioBtn_YesNo(false);
    };
    var handleShippingCostApply = function (param) {
        setApplyShippingCost(APPLY_SHIPPING_COST_YES);
        setShippingCost(param);
        if (param === SELECT_SHIPPING_AT_CHECKOUT) {
            setSelectedOrderType(CREATE_CHECKOUT);
        }
    };
    var checkAddressInputField = function () {
        var _a;
        for (var index = 0; index < ((_a = inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress) === null || _a === void 0 ? void 0 : _a.length); index++) {
            if ((inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress[index][index]) === "") {
                setAlertErrorMsg({ msg: inputFieldsData === null || inputFieldsData === void 0 ? void 0 : inputFieldsData.newAddress[index].errorMsg, open: true, severity: "warning" });
                break;
            }
        }
    };
    var handleUpdateReduxState = function (payloadData, actionType) {
        var action = {
            payload: payloadData,
            type: actionType,
        };
        dispatch(action);
    };
    var checkIsPlacingMessage = function () {
        var isPlacingOrder = orderPlacedMsg.msg === t("customerInvoice_Sending_Msg") ||
            orderPlacedMsg.msg === t("customerInvoice_Creating_Msg") ||
            orderPlacedMsg.msg === t("customerInvoice_CreatingDraft_Msg") ||
            orderPlacedMsg.msg === t("customerInvoice_CreatingDraftCheckout");
        return isPlacingOrder;
    };
    var handleOpenConfirm = function () {
        if (applyShippingCost === APPLY_SHIPPING_COST_YES && shippingCost === "") {
            setAlertErrorMsg({ msg: t("customerInvoice_EditOrder_NoAutoSelectedShippingCost"), open: true, severity: "warning" });
            return;
        }
        else {
            setIsConfirmOpen(!isConfirmOpen);
        }
    };
    var orderCreateBtnDisabled = selectedOrderType != "" &&
        (selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.length) > 0 &&
        !checkIsPlacingMessage() &&
        props.customerInfo.customerName.trim() !== "" &&
        props.customerInfo.emailId.trim() !== "" &&
        (props === null || props === void 0 ? void 0 : props.email_validation) === false &&
        ((props === null || props === void 0 ? void 0 : props.zip_validation) === false || ((_v = props === null || props === void 0 ? void 0 : props.customerInfo) === null || _v === void 0 ? void 0 : _v.shippingAddress)) &&
        ((props === null || props === void 0 ? void 0 : props.mobile_validation) === false || (props === null || props === void 0 ? void 0 : props.mobile_validation) === "") &&
        ((_w = Object.values(isQuantityError)) === null || _w === void 0 ? void 0 : _w.every(function (value) { return !value; })) &&
        ((_x = Object.values(isDiscountError)) === null || _x === void 0 ? void 0 : _x.every(function (value) { return !value; })) &&
        !(shippingCost === t("customerInvoice_CalculatingShippingRates_Msg"));
    var shouldShowPaymentTermsValue = shouldShowPaymentTerms(selectFeatures, selectedOrderType, editOrderReduxData, paymentTerms, isEditOrder);
    return {
        orderCreateBtnDisabled: orderCreateBtnDisabled,
        handleOpenConfirm: handleOpenConfirm,
        isConfirmOpen: isConfirmOpen,
        selectedOrderType: selectedOrderType,
        t: t,
        salesRepData: salesRepData,
        orderNotes: orderNotes,
        setOrderNotes: setOrderNotes,
        orderPlacedMsg: orderPlacedMsg,
        CreateOrder: CreateOrder,
        handleAlertMsgClose: handleAlertMsgClose,
        shippingCost: shippingCost,
        setShippingCost: setShippingCost,
        alertErrorMsg: alertErrorMsg,
        handleSelectShippingAddress: handleSelectShippingAddress,
        shippingAddresSet: shippingAddresSet,
        shippingCostData: shippingCostData,
        handleShippingCostApply: handleShippingCostApply,
        applyShippingCost: applyShippingCost,
        setApplyShippingCost: setApplyShippingCost,
        isDisabledShippingCostRadioBtn_YesNo: isDisabledShippingCostRadioBtn_YesNo,
        selectFeatures: selectFeatures,
        isMobile: isMobile,
        checkIsPlacingMessage: checkIsPlacingMessage,
        orderCreatedSuccessfully: orderCreatedSuccessfully,
        sendInvoiceFeature: sendInvoiceFeature,
        setSendInvoiceFeature: setSendInvoiceFeature,
        handleOrderTypeChange: handleOrderTypeChange,
        defaultPopupStateFromDb: defaultPopupStateFromDb,
        handleUpdateReduxState: handleUpdateReduxState,
        setOrderCreatedSuccessfully: setOrderCreatedSuccessfully,
        selectedProductData: selectedProductData,
        handleApplyShippingRadio: handleApplyShippingRadio,
        orderOptions: orderOptions,
        openSelectShippingFlag: openSelectShippingFlag,
        setOpenSelectShippingFlag: setOpenSelectShippingFlag,
        createOrderBtnLoader: createOrderBtnLoader,
        discountApplyOnCheckout: discountApplyOnCheckout,
        setDiscountApplyOnCheckout: setDiscountApplyOnCheckout,
        orderPONumber: orderPONumber,
        setOrderPONumber: setOrderPONumber,
        setAutomaticDiscountOnCheckout: setAutomaticDiscountOnCheckout,
        automaticDiscountOnCheckout: automaticDiscountOnCheckout,
        paymentTerms: paymentTerms,
        setPaymentTerms: setPaymentTerms,
        editOrderReduxData: editOrderReduxData,
        isEditOrder: isEditOrder,
        shouldShowPaymentTerms: shouldShowPaymentTermsValue,
    };
}
